export function addSizeToDataLayer( dimension: string, value: number|string, shape: string ): void {
	if ( ! dimension || ! value ) {
		return;
	}

	window?.dataLayer?.push( {
		event: 'measurements_selector',
		eventCategory: 'Shapes & Sizes: ' + document.title,
		eventAction: 'Step 3: Set size',
		eventLabel: window.measurementSelectorVariables.i18n.dimensionNames[dimension],
		eventValue: shape,
	} );
}
